import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import PropTypes from "prop-types";
import { marketPlaceListing } from '../../../store/actions/marketplace.action';
import "./AddToMarketplaceModal.css";

// Marketplace Tile Component - renders individual marketplace card
const MarketplaceTile = ({ marketplace, isSelected, onToggle }) => {
  return (
    <button
      key={marketplace.channel_id}
      className="col-lg-3 col-sm-12 sortBtn"
      onClick={() => onToggle(marketplace.channel_id)}
      style={{ border: 'none', padding: '0', background: 'none' }}
    >
      <div className={`integrationCard ${isSelected ? 'selected' : ''}`}>
        {isSelected && (
          <div className="selected-checkmark">
            <i className="fa fa-check" aria-hidden="true"></i>
          </div>
        )}
        <div className="image">
          <img
            src={marketplace.channel_logo}
            alt={marketplace.channel_name}
            style={{ maxWidth: '100%', cursor: 'pointer', maxHeight: '100px' }}
          />
        </div>
        <button
          className="btn cus-primary-bg-btn custom-btn-shipment ingration"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          {marketplace.channel_name}
        </button>
      </div>
    </button>
  );
};

MarketplaceTile.propTypes = {
  marketplace: PropTypes.shape({
    channel_id: PropTypes.string.isRequired,
    channel_logo: PropTypes.string.isRequired,
    channel_name: PropTypes.string.isRequired,
  }).isRequired,
  isSelected: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
};

// Marketplace Grid Component - renders grid of marketplace tiles
const MarketplaceGrid = ({ marketplaces, selectedMarketplaces, onToggle }) => {
  return (
    <div className="integrationListWrapper row">
      {marketplaces.map((marketplace) => {
        const isSelected = selectedMarketplaces.includes(marketplace.channel_id);
        return (
          <MarketplaceTile
            key={marketplace.channel_id}
            marketplace={marketplace}
            isSelected={isSelected}
            onToggle={onToggle}
          />
        );
      })}
    </div>
  );
};

MarketplaceGrid.propTypes = {
  marketplaces: PropTypes.arrayOf(
    PropTypes.shape({
      channel_id: PropTypes.string.isRequired,
      channel_logo: PropTypes.string.isRequired,
      channel_name: PropTypes.string.isRequired,
    })
  ).isRequired,
  selectedMarketplaces: PropTypes.arrayOf(PropTypes.string).isRequired,
  onToggle: PropTypes.func.isRequired,
};

// Main Modal Component
const AddToMarketplaceModal = (props) => {
  const { show, onHide, onMarketplaceSelect } = props;
  const [selectedMarketplaces, setSelectedMarketplaces] = useState([]);
  const [localMarketplaces, setLocalMarketplaces] = useState([]);

  useEffect(() => {
    if (show) {
      fetchMarketplaceData();
    }
  }, [show]);

  const fetchMarketplaceData = async () => {
    try {
      const resData = await Promise.resolve(marketPlaceListing(0));
      if (resData?.data?.Status === 200) {
        const marketplaces = resData.data.EntityList || [];
        setLocalMarketplaces(marketplaces);
      }
    } catch (error) {
      console.error('Error fetching marketplace data:', error);
    }
  };

  const toggleMarketplace = (marketplaceId) => {
    setSelectedMarketplaces((prev) => {
      if (prev.includes(marketplaceId)) {
        return prev.filter((id) => id !== marketplaceId);
      } else {
        return [...prev, marketplaceId];
      }
    });
  };

  const handleAddToMarketplaces = () => {
    if (onMarketplaceSelect) {
      onMarketplaceSelect(selectedMarketplaces);
    }
    setSelectedMarketplaces([]);
    onHide(false);
  };

  const handleModalClose = () => {
    setSelectedMarketplaces([]);
    onHide(false);
  };

  return (
    <Modal
      show={show}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={handleModalClose}
      className='generateKey modalDeleteWrapper'
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Add to Marketplace
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <MarketplaceGrid
          marketplaces={localMarketplaces}
          selectedMarketplaces={selectedMarketplaces}
          onToggle={toggleMarketplace}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleModalClose}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={handleAddToMarketplaces}
          disabled={selectedMarketplaces.length === 0}
        >
          Add to Marketplaces
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

AddToMarketplaceModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onMarketplaceSelect: PropTypes.func,
};

export default AddToMarketplaceModal;
